import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetDisciplineParams extends PaginationProps {}

interface CreateDiscipline {
  name: string;
  cfihosName: string;
}

interface UpdateDiscipline extends CreateDiscipline {
  id: number | null;
}

export async function getDisciplines() {
  const { data } = await api.get('/disciplines');
  return data;
}

export async function getDisciplinesMasterData(params: GetDisciplineParams) {
  const { data } = await api.get('/disciplines/master-data', {
    params
  });
  return data;
}

export async function getDiscipline(id: number) {
  const { data } = await api.get(`/disciplines/${id}`);
  return data;
}

export async function createDiscipline(createDiscipline: CreateDiscipline) {
  const { data } = await api.post('/disciplines', createDiscipline);
  return data;
}

export async function updateDiscipline(updateDiscipline: UpdateDiscipline) {
  const { data } = await api.put(
    `/disciplines/${updateDiscipline.id}`,
    updateDiscipline
  );
  return data;
}

export function deleteDiscipline(id: number) {
  return api.delete(`/disciplines/${id}`);
}
